export const CONSENT_STORAGE_KEY = "litiosur_cookie_consent_v1";

export const DENIED_CONSENT = {
  necessary: true,
  analytics: false,
  ads: false,
  personalization: false,
};

export const GRANTED_CONSENT = {
  necessary: true,
  analytics: true,
  ads: true,
  personalization: true,
};

const isBrowser = () => typeof window !== "undefined";

function gtagSafe() {
  if (!isBrowser()) return null;
  if (typeof window.gtag === "function") return window.gtag;
  window.dataLayer = window.dataLayer || [];
  const fallback = function () {
    // eslint-disable-next-line prefer-rest-params
    window.dataLayer.push(arguments);
  };
  return fallback;
}

export function toConsentSignals(choice) {
  return {
    ad_storage: choice.ads ? "granted" : "denied",
    ad_user_data: choice.ads ? "granted" : "denied",
    ad_personalization: choice.personalization ? "granted" : "denied",
    analytics_storage: choice.analytics ? "granted" : "denied",
    personalization_storage: choice.personalization ? "granted" : "denied",
    functionality_storage: "granted",
    security_storage: "granted",
  };
}

/**
 * Reusable Consent Mode v2 update helper.
 * Sends gtag('consent','update', ...) and pushes the dataLayer event.
 */
export function updateConsent(choice) {
  if (!isBrowser()) return;
  const signals = toConsentSignals(choice);
  const gtag = gtagSafe();
  if (gtag) {
    gtag("consent", "update", signals);
  }
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: "cookie_consent_update",
    consent_analytics: signals.analytics_storage,
    consent_ads: signals.ad_storage,
    consent_personalization: signals.ad_personalization,
  });
}

export function readStoredConsent() {
  if (!isBrowser()) return null;
  try {
    const raw = window.localStorage.getItem(CONSENT_STORAGE_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    if (!parsed || typeof parsed !== "object") return null;
    return {
      necessary: true,
      analytics: Boolean(parsed.analytics),
      ads: Boolean(parsed.ads),
      personalization: Boolean(parsed.personalization),
      timestamp: parsed.timestamp || null,
    };
  } catch (err) {
    return null;
  }
}

export function persistConsent(choice) {
  if (!isBrowser()) return;
  try {
    window.localStorage.setItem(
      CONSENT_STORAGE_KEY,
      JSON.stringify({
        necessary: true,
        analytics: Boolean(choice.analytics),
        ads: Boolean(choice.ads),
        personalization: Boolean(choice.personalization),
        timestamp: new Date().toISOString(),
        version: 1,
      }),
    );
  } catch (err) {
    /* storage unavailable — consent stays denied for this session */
  }
}

export function saveConsent(choice) {
  persistConsent(choice);
  updateConsent(choice);
}

/** Re-apply a previously saved decision on subsequent visits. */
export function applyStoredConsent() {
  const stored = readStoredConsent();
  if (stored) {
    updateConsent(stored);
  }
  return stored;
}
